import React, { useState, useCallback, useContext } from 'react';
import { Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import { ProjectContext } from "../../context/project_context";

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ProjectUploadVideo = () => {
  const { saveVideoUrlToProject, project, updateProject } = useContext(ProjectContext);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState(null);

  const handleFileSelect = useCallback(async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      // Get presigned URL from your backend
      const response = await fetch('/api/s3/presigned_url', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fileName: file.name,
          fileType: file.type,
        }),
      });
      
      const { url, fields } = await response.json();

      // Create form data for upload
      const formData = new FormData();
      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append('file', file);

      // Upload to S3
      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          const percentComplete = (event.loaded / event.total) * 100;
          setUploadProgress(percentComplete);
        }
      });

      xhr.addEventListener('load', async () => {
        if (xhr.status === 201) {
          const finalUrl = `${url}/${fields.key}`;
          setUploadedUrl(finalUrl);
          await saveVideoUrlToProject(finalUrl);
          alert('Upload completed successfully!');
        } else {
          setUploadError('Upload failed');
        }
      });

      xhr.addEventListener('error', () => {
        setUploadError('Upload failed');
      });

      xhr.open('POST', url, true);
      xhr.send(formData);

    } catch (error) {
      console.error('Error:', error);
      setUploadError(error.message);
    }
  }, []);

  const handleSkip = async () => {
    await updateProject({
      ...project,
      project_status: "split_video" // Assuming this is the next status
    });
  };

  return (
    <div className="upload-video-container">
      <h5>Upload Project Video</h5>
      
      <div className="d-flex gap-2">
        <Button
          component="label"
          variant="contained"
          startIcon={<CloudUploadIcon />}
        >
          Upload Video
          <VisuallyHiddenInput
            type="file"
            accept="video/*"
            onChange={handleFileSelect}
          />
        </Button>

        <Button 
          variant="outlined"
          onClick={handleSkip}
        >
          Skip Video Upload
        </Button>
      </div>

      {uploadProgress > 0 && uploadProgress < 100 && (
        <div className="upload-progress">
          <progress value={uploadProgress} max="100" />
          <span>{Math.round(uploadProgress)}%</span>
        </div>
      )}

      {uploadError && (
        <div className="upload-error">
          {uploadError}
        </div>
      )}

      {uploadedUrl && (
        <div className="upload-success">
          <p>Upload completed successfully!</p>
          <video controls src={uploadedUrl} style={{ maxWidth: '100%' }} />
        </div>
      )}
    </div>
  );
};

export default ProjectUploadVideo; 